import { Box } from '@mui/material';
import {
    Create,
    FormDataConsumer,
    Labeled,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
    Toolbar,
    useChoicesContext
} from 'react-admin';
import Permission from '../../components/Permission';
import SaveConfirmButton from '../../components/SaveConfirmButton';
import { PERMISSIONS } from '../../constants';

const containerSx = {
    display: 'flex',
    flexDirection: 'column',
    width: 300,
    marginTop: 40,
};

const FuelGroupInput = ({ formData }) => {
    const { allChoices } = useChoicesContext();
    if (!formData.fuels) { formData.fuels = []; }

    return allChoices && allChoices.map(({ id, name }, index) => {
        if (formData.fuels[index]) {
            formData.fuels[index].fuelId = id;
        }

        return (
            <Labeled label={name}>
                <TextInput
                    source={`fuels[${index}].factor`}
                    label="Fator Pontos/Litro"
                    defaultValue={0}
                    format={value => (!value ? '0,00' : `${Number(value).toFixed(2)}`)}
                    parse={value => (!value ? 0 : +value.replace(/[^\d]/g, '') / 100)}
                />
            </Labeled>
        );
    });
}

const GroupRulesCreate = (props) => {

    const ToolbarCustom = (props) => {
        return (
            <Toolbar {...props}>
                <FormDataConsumer>
                    {({ formData, ...rest }) => (
                        <SaveConfirmButton
                            {...rest}
                            formData={formData}
                            validate={(data) => {
                                return data.fuels && data.fuels.some(grf => grf.factor > 2);
                            }}
                            contentMessage="A pontuação parece estar muito alta. Deseja confirmar?"
                        />)}
                </FormDataConsumer>
            </Toolbar>
        );
    };

    const sanitize = (data) => {
        return { ...data, fuels: data.fuels.filter(f => 'factor' in f && f.factor !== undefined) };
    }

    return (
        <Permission permission={PERMISSIONS.RULES_BY_GROUP}>
            <Create {...props} title='Criar regra para grupo de clientes' transform={sanitize}>
                {/* <SimpleForm toolbar={<ToolbarCustom />}> */}
                <SimpleForm>
                    <Box sx={containerSx}>
                        <ReferenceInput
                            source="groupId"
                            reference="chains/chainId/customer-groups"
                            sort={{ field: 'name', order: 'ASC' }}
                            filter={{ groupRuleId: null }}
                        >
                            <SelectInput
                                label="Grupo"
                                optionText="name" />
                        </ReferenceInput>
                        <FormDataConsumer>
                            {({ formData }) => formData.groupId && (
                                <ReferenceInput
                                    sort={{ field: 'name', order: 'ASC' }}
                                    label=""
                                    source="id"
                                    reference="fuels"
                                >
                                    <FuelGroupInput formData={formData} />
                                </ReferenceInput>
                            )
                            }
                        </FormDataConsumer>
                    </Box>
                </SimpleForm>
            </Create>
        </Permission>
    );
};

export default GroupRulesCreate;
